import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersubfull } from "../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { TableCongNoThanhLy } from "./TableCongNoThanhLy";
import { BtnXuatDanhSach } from "components/CongNoThanhLy/ChucNang/XuatDanhSach/BtnXuatDanhSach";

import StoreApi from "service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const CongNoThanhLy = () => {
  const initPhanQuyen = {
    congnothanhly_danhsach: false,
    congnothanhly_thanhtoan: false,
    congnothanhly_xoa: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  useEffect(() => {
    LoadPhanQuyen();
  }, []);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenCongNoThanhLy().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        congnothanhly_danhsach: response.data.congnothanhly_danhsach,
        congnothanhly_thanhtoan: response.data.congnothanhly_thanhtoan,
        congnothanhly_xoa: response.data.congnothanhly_xoa,
      });
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.congnothanhly_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Công nợ thanh lý
                          </h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              <BtnXuatDanhSach />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableCongNoThanhLy
            quyenThanhToan={phanQuyen.congnothanhly_thanhtoan}
            quyenXoa={phanQuyen.congnothanhly_xoa}
          />
        </div>
      )}
      {!phanQuyen.congnothanhly_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                 <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                           Công nợ thanh lý
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
